import { createAsyncThunk } from "@reduxjs/toolkit";
import { DeletePricingPlan } from "./pricingPlanTypeSlice";
import { ApiResponse } from "../../../types/APIResponse";
import api, {apiWithFormDataMethods} from "../../../utils/constants/api";
import { apiEndpoints } from "../../../utils/constants/apiEndpoints";
import {Features, PricingPlan} from "../../../types";

// Async Thunks
export const fetchPricingPlan = createAsyncThunk<PricingPlan[], void, { rejectValue: string }>(
    'PricingPlan/fetchPricingPlan',
    async (_, { rejectWithValue }) => {
        try {
            const response = await api.get<ApiResponse<PricingPlan[]>>(apiEndpoints.pricingPlan.getAll);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.message || 'Failed to fetch pricing Plans');
        }
    }
);

export const addPricingPlan = createAsyncThunk<PricingPlan, any, { rejectValue: string }>(
    'PricingPlan/addPricingPlan',
    async ( data , { rejectWithValue }) => {
        try {
            const response = await api.post<ApiResponse<PricingPlan>>(apiEndpoints.pricingPlan.create, {data});
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.message || 'Failed to add PricingPlan');
        }
    }
);

export const updatePricingPlan = createAsyncThunk<PricingPlan, any, { rejectValue: string }>(
    'PricingPlan/updatePricingPlan',
    async ({ id, ...rest } , { rejectWithValue }) => {
        try {
            const response = await api.put<ApiResponse<PricingPlan>>(`${apiEndpoints.pricingPlan.update}/${id}`, {data: rest} );
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.message || 'Failed to update PricingPlan');
        }
    }
);

export const deletePricingPlan = createAsyncThunk<DeletePricingPlan, { id: string }, { rejectValue: string }>(
    'PricingPlan/deletePricingPlan',
    async ({ id }, { rejectWithValue }) => {
        try {
            const response = await api.delete<ApiResponse<DeletePricingPlan>>(`${apiEndpoints.pricingPlan.delete}/${id}`);
            return { ...response.data, id };
        } catch (error: any) {
            return rejectWithValue(error.message || 'Failed to delete PricingPlan');
        }
    }
);
